/**
 * Copyright (C) 2018 Egylis,
 * Siège social, 46 rue René Clair, 75892 PARIS cedex 18 - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 07/12/18.
 *
 * Version : Generator 2.0.9
 */

import {MetaIndex} from '../defEntity';
import {OrderEnum} from './orderEnum';
import {WhereQuery} from './whereQuery';
import {ExprQuery} from './exprQuery';
import {MOEntity} from '../entity';
import {MOEntityMeta} from '../metaEntity';

/**
 * Query
 */
export class Query<T extends MOEntity> {
    /**
     * Query Class
     */
    private readonly _queryClass: MOEntityMeta<T>;
    /**
     * Limit
     */
    private _limit: number = -1;
    /**
     * Offset
     */
    private _offset: number = -1;
    /**
     * Index Sort
     */
    private _indexSort: MetaIndex = null;
    /**
     * Order Enum
     */
    private _orderSort: OrderEnum = OrderEnum.ASC;
    /**
     * Where
     */
    private _where: WhereQuery = null;
    /**
     * Where
     */
    private _expression: ExprQuery = null;

    /**
     * Constructor
     * @param queryClass query Class
     */
    constructor(queryClass: MOEntityMeta<T>) {
        this._queryClass = queryClass;
    }

    /**
     * Add a limit
     * @param limit the new limit
     */
    public addLimit(limit: number): Query<T> {
        this._limit = limit;
        return this;
    }

    /**
     * Add an offset
     * @param offset the new offset
     */
    public addOffset(offset: number): Query<T> {
        this._offset = offset;
        return this;
    }

    /**
     * Set an order
     * @param index the index column
     * @param order the order
     */
    public addIndex(index: MetaIndex, order: OrderEnum): Query<T> {
        this._indexSort = index;
        this._orderSort = order;
        return this;
    }

    /**
     * Set the where clause
     * @param where the where clause
     */
    public addWhere(where: WhereQuery): Query<T> {
        this._where = where;
        return this;
    }

    /**
     * Set the filter clause
     * @param expr the filter clause
     */
    public addExpr(expr: ExprQuery): Query<T> {
        this._expression = expr;
        return this;
    }


    /**
     * Getter
     */
    public get queryClass(): MOEntityMeta<T> {
        return this._queryClass;
    }

    /**
     * Getter
     */
    public get limit(): number {
        return this._limit;
    }

    /**
     * Getter
     */
    public get offset(): number {
        return this._offset;
    }

    /**
     * Getter
     */
    public get indexSort(): MetaIndex {
        return this._indexSort;
    }

    /**
     * Getter
     */
    public get orderSort(): OrderEnum {
        return this._orderSort;
    }

    /**
     * Getter
     */
    public get where(): WhereQuery {
        return this._where;
    }

    /**
     * Getter
     */
    public get expression(): ExprQuery {
        return this._expression;
    }
}
